import { axios } from 'shared/services/axios'

export function fetchEventUrls(boardId) {

  return axios.get(`/live_board/v2/boards/${boardId}/live_event`)
    .then(response => response.data)
}
